import { LogLevel } from 'src/app/common/utility/logger/logLevel';
import { Common } from './common';
import { Environments } from './environments';

export class Environment extends Common {
  static {
    super.LogLevel = LogLevel.Debug;
    super.Environment = Environments.Production

    super.ApiUrl = super.UserApi = super.ReportsApi ="https://spbelhbqp1.execute-api.us-east-1.amazonaws.com/prod"
    super.SocketUrl = "wss://xc4b3li7s6.execute-api.us-east-1.amazonaws.com/prod"
    super.SocketPingRateMinutes = 5
  }
}

//https://spbelhbqp1.execute-api.us-east-1.amazonaws.com/prod/edgeDevice